import { render, staticRenderFns } from "./MoneyCheckbox.vue?vue&type=template&id=06f4e217&scoped=true&"
import script from "./MoneyCheckbox.vue?vue&type=script&lang=js&"
export * from "./MoneyCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MoneyCheckbox.vue?vue&type=style&index=0&id=06f4e217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4e217",
  null
  
)

export default component.exports